import styled, { keyframes } from 'styled-components';
import { theme } from '@/styles/theme';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  gap: ${theme.spacing.md};
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid ${theme.colors.border};
  border-top-color: ${theme.colors.primary};
  border-radius: ${theme.borderRadius.full};
  animation: ${spin} 0.8s linear infinite;
`;

const LoadingText = styled.p`
  color: ${theme.colors.textLight};
  font-size: ${theme.fontSizes.md};
  font-weight: 500;
`;

interface LoadingSpinnerProps {
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ text = 'טוען...' }) => {
  return (
    <SpinnerContainer role="status" aria-label="טוען">
      <Spinner />
      <LoadingText>{text}</LoadingText>
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
